import { useContext } from "react";
import { LendicaContext } from "../contexts/LendicaContext";

export const useLendicaContext = () => {
  return useContext(LendicaContext);
};
